import React from "react";

// Buton segmentat Da | Nu pentru întrebări cu răspuns binar în formulare.
// value: true (Da) / false (Nu) / null|undefined (neselectat)
export const YesNoToggle = ({ value, onChange, testid, disabled }) => {
  const base = "px-5 py-1.5 text-sm font-semibold rounded-md transition-colors border";
  return (
    <div className="inline-flex gap-2" data-testid={testid}>
      <button
        type="button"
        disabled={disabled}
        data-testid={testid ? `${testid}-yes` : undefined}
        onClick={() => onChange(true)}
        className={`${base} ${value === true
          ? "bg-emerald-600 text-white border-emerald-600"
          : "bg-white text-gray-600 border-gray-300 hover:bg-emerald-50"}`}
      >
        Da
      </button>
      <button
        type="button"
        disabled={disabled}
        data-testid={testid ? `${testid}-no` : undefined}
        onClick={() => onChange(false)}
        className={`${base} ${value === false
          ? "bg-red-600 text-white border-red-600"
          : "bg-white text-gray-600 border-gray-300 hover:bg-red-50"}`}
      >
        Nu
      </button>
    </div>
  );
};

// Rând etichetă + toggle Da/Nu, aliniat pe orizontală
export const YesNoRow = ({ label, value, onChange, testid, disabled, children }) => (
  <div className="flex items-start justify-between gap-4 py-2">
    <div className="flex-1">
      <p className="font-medium text-gray-800">{label}</p>
      {children}
    </div>
    <YesNoToggle value={value} onChange={onChange} testid={testid} disabled={disabled} />
  </div>
);

export default YesNoToggle;
